import { createGlobalStyle } from 'styled-components';
import antCustomTheme from '~/ui/theme/antd/theme';
import { themeColor } from '~/common/utils/theme';

const globalStyle = createGlobalStyle`
  /*
   * Dark-theme bridge for legacy react-with-styles/Aphrodite screens.
   * Aphrodite bakes color strings into static classes and does not recompute
   * on a React theme change, but it DOES emit \`var(--mt-*)\` references verbatim.
   * This GlobalStyle re-renders whenever the active theme changes, so the
   * variables below flip light<->dark live and every Aphrodite-styled element
   * that references them follows along without any per-component rework.
   */
  :root {
    --mt-surface: ${themeColor('background.primary', { dark: 'background.secondary' })};
    --mt-bg-primary: ${themeColor('background.primary')};
    --mt-bg-secondary: ${themeColor('background.secondary')};
    --mt-bg-tertiary: ${themeColor('background.tertiary')};
    --mt-text-primary: ${themeColor('element.primary')};
    --mt-text-secondary: ${themeColor('element.secondary')};
    --mt-text-placeholder: ${themeColor('element.placeholder')};
    --mt-divider: ${themeColor('divider.primary')};
    --mt-border: ${themeColor('element.disabled')};
    --mt-brand: ${themeColor('brand.primary')};
    --mt-positive: ${themeColor('positive.primary')};
    --mt-negative: ${themeColor('negative.primary')};
    --mt-alert: ${themeColor('alert.primary')};
    --mt-info: ${themeColor('info.primary')};
  }

  * {
    margin: 0;
    padding: 0;

    *::-webkit-scrollbar {
      width: 8px;
    }

    *::-webkit-scrollbar-track {
      border: none;
      border-radius: 0;
      background-color: ${themeColor('background.primary', {
        dark: 'background.secondary',
      })};
    }

    *::-webkit-scrollbar-thumb {
      border-radius: 8px;
      border: 1px solid transparent;
      background-clip: content-box;
      background-color: #666666;
    }
  }

  body {
    font-family: ${({ theme }) => theme.typography.fonts[theme.typography.defaultFamily]} !important;
    /* Theme-aware default text color so any element without an explicit color stays
       legible in dark mode. !important to win over antd's global \`body { color }\` rule. */
    color: ${themeColor('element.primary')} !important;
  }

  #root {
    height: 100%;
    width: 100%;
  }

  .App {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    background-color: ${themeColor('background.secondary', { dark: 'background.tertiary' })};
  }

  .content {
    flex: 1;
    width: 100%;
    overflow: auto;
    padding: 32px 24px;
  }

  .content.no-padding {
    padding: 0;
  }

  .content.overflow-hidden {
    overflow: hidden;
  }
  
  .no-scroll {
    overflow: hidden;
  }

  main {
    background: ${themeColor('background.secondary', { dark: 'background.tertiary' })};
  }
  
  ${antCustomTheme};
`;

export default globalStyle;
